export enum SortDirection {
    asc = 'asc',
    desc = 'desc',
    none = ''
}

export enum AlignType {
    left = 'left',
    center = 'center',
    right = 'right',
    start = 'start'
}

export enum FilterOptionsType {
    text = 'text',
    number = 'number',
    date = 'date',
    dateRange = 'dateRange',
    time = 'time',
    timeRange = 'timeRange',
    dateTime = 'dateTime',
    dateTimeRange = 'dateTimeRange',
    boolean = 'boolean',
    currency = 'currency',
    percent = 'percent',
    image = 'image',
    icon = 'icon',
    select = 'select',
    isSelect = 'isSelect',
    custom = 'custom'
}

export enum ColumnType {
    text = 'text',
    number = 'number',
    numberBadge = 'numberBadge',
    date = 'date',
    dateTime = 'dateTime',
    dateRange = 'dateRange',
    boolean = 'boolean',
    currency = 'currency',
    percent = 'percent',
    image = 'image',
    icon = 'icon',
    custom = 'custom',
    labels = 'labels',
    rating = 'rating',
    select = 'select',
    country = 'country',
    picture = 'picture',
    link = 'link',
    multiselect = 'multiselect',
    chipSet = 'chipSet',
    progressRing = 'progressRing',
}

export enum FilterOperator {
    contains = 'contains',
    notContains = 'notContains',
    equals = 'equals',
    notEquals = 'notEquals',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    greaterThan = 'greaterThan',
    lessThan = 'lessThan',
    greaterThanOrEqual = 'greaterThanOrEqual',
    lessThanOrEqual = 'lessThanOrEqual',
    between = 'between',
    notBetween = 'notBetween',
    isNull = 'isNull',
    isNotNull = 'isNotNull',
    isEmpty = 'isEmpty',
    isNotEmpty = 'isNotEmpty',
    in = 'in',
    notIn = 'notIn',
    or = 'or'
}